<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Joueurs</label>
      </div>
      <select class="custom-select"
              disabled
              name="sanction_joueur">
        <option>
          {{(joueur) ?
                joueur.prenom.charAt(0).toUpperCase() + joueur.prenom.slice(1).toLowerCase() + ' ' +
                joueur.postnom.charAt(0).toUpperCase() + joueur.postnom.slice(1).toLowerCase() + ' ' +
                joueur.nom.charAt(0).toUpperCase() + joueur.nom.slice(1).toLowerCase() : ''
          }}
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Carton jaune</label>
      </div>
      <input :value="sanction.carton_jaune"
             disabled
             class="form-control"
             name="sanction_carton_jaune"
             placeholder="Entrez le nombre de cartons jaune"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Carton rouge</label>
      </div>
      <input :value="sanction.carton_rouge"
             disabled
             class="form-control"
             name="sanction_carton_rouge"
             placeholder="Entrez le nombre de cartons rouge"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Match</label>
      </div>
      <select class="custom-select"
              disabled
              name="sanction_match">
        <option>
          {{ (equipes && match) ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_a_id )[0].nom.toUpperCase() : '' }}
          vs
          {{ (equipes && match) ? equipes.filter( (equipe) => equipe.equipe_id === match.equipe_b_id )[0].nom.toUpperCase() : '' }}
          ({{ (match) ? (new Date(match.date_rencontre).toLocaleDateString() + ' - ' + match.temps_rencontre) : '' }})
        </option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text">Causes de la sanction</label>
      </div>
      <textarea :value="sanction.raison_sanction"
                disabled
                class="form-control"
                name="sanction_raison"
                placeholder="Entrez un court commentaire sur les causes de la sanction"
                type="email">
      </textarea>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="sanction.date_creation"
             name="sanction_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="sanction.temps_creation"
             name="sanction_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="sanction.date_modification"
             name="sanction_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="sanction.temps_modification"
             name="sanction_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
  name: "Read",
  props: {
    sanction: {
      type: Object
    }
  },
  data(){
    return{
      equipes: null,
      joueur: null,
      match: null,
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
      'axiosGetOneData'
    ]),
  },
  computed: {
    ...mapGetters([

    ])
  },
  beforeCreate() {},
  created() {
    //
    this.axiosGetAllData({
      table: "equipes",
    })
        .then( (data) => {
          this.equipes = data.data
        })
        .catch( () => {
          console.log(data)
        })
    //
    this.axiosGetAllData({
      table: "matchs_joues",
    })
        .then( (data) => {
          const matchs = data.data
          this.match = matchs.filter((match) => match.match_id === this.sanction.match_id)[0]
        })
        .catch( () => {
          console.log(data)
        })
    //
    this.axiosGetOneData({
      table: "joueurs",
      table_id: this.sanction.joueur_id
    })
        .then( (data) => {
          this.joueur = data.data
        })
        .catch( () => {
          console.log(data)
        })
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cartons/components/Read.vue